export const ScreenShotEnum = [
  'mobile-apply-branch-adjust-from-base-shot',
  'mobile-apply-beloan-adjust-from-base-shot'
]
